import withAuth, { AuthProps } from "components/decorator/WithAuth"
import { setFormData } from "components/Ielts/IeltsDemo/redux/IeltsDemoSlice"
import {
  fetchGetIeltsStage,
  fetchInboundSalesNumberSlice,
  fetchPostIeltsEliteNudgeForm,
  IeltsStageType,
  runIeltsQualificationEngineAction,
  updatePostFillIeltsEliteNudgeForm,
  updatePostGetStageAction,
  UserQeData,
} from "components/Ielts/IeltsEliteDemo/redux/IeltsEliteSlice"
import { ieltsEliteFormRequiredFields } from "components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/ieltsEliteFormJson"
import { LoginProps } from "components/Login/withLogin"
import { isObjectEmpty } from "components/TofuOnbordingForms/utils"
import { fireTagEvent } from "ga"
import { State } from "Interfaces/storeSchema"
import { NextPage } from "next"
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { trackEventAsync, trackPageV2 } from "scripts/segment"
import { ieltsPageName } from "utils/events-utils"
import sha256 from "crypto-js/sha256"
import { DemoFormAbVariants } from "DataMapper/IeltsProfile/IeltsDemo"
import useDemoAlias from "hooks/ielts/useDemoAlias"
import { checkIfMENAUser } from "utils/country_utils"
import useLocation from "hooks/login/useLocation"
import { isMobile, isMobile as mobileView } from "react-device-detect"
import { referAndEarnActions } from "components/Profile/ReferAndEarn/redux/ReferAndEarnActions"
import LiyThankyouPage2 from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2"
import useABTesting from "hooks/useABTesting"
import { ieltsEliteApis } from "components/Ielts/IeltsEliteDemo/redux/IeltsEliteApi"
import { liyABVariant } from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/constant"
import LiyFlowThankyouPage from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/LiyFlowThankyouPage"

const PageLoadingView = dynamic(
  () => import("components/TofuCommonComponents/PageLoadingView"),
  { loading: () => <p>...</p> },
)

export enum IeltsExamType {
  ACADEMIC = "ACADEMIC",
  GENERAL = "GENERAL",
  OTHER = "OTHER",
}

export const getFilteredFormDataFromQueryObject = (givenData: any) => {
  const newData = { ...givenData }
  const requiredFormValues = new Set(ieltsEliteFormRequiredFields)
  for (const key in newData) {
    if (!requiredFormValues.has(key)) delete newData[key]
  }
  return newData
}
type Props = AuthProps &
  LoginProps & {
    getSchedule: Function
    getScheduleunAuthenticated: Function
    getStage: Function
    error: string
  }

const Calender: NextPage<Props> = ({ auth }) => {
  const { userInfo } = useSelector((state: State) => state.referAndEarn)
  const { ieltsStage } = useSelector((state: State) => state.IeltsElite)
  const { abVariant } = useABTesting("ielts_liy_thank_you")

  const { userCountry } = useLocation()
  const router = useRouter()
  const formDetailsObjectFromQuery: Record<string, any> = {
    ...getFilteredFormDataFromQueryObject(router.query),
    phone: userInfo?.phone,
  }
  const { formStage, abTest, leadSource, country, flow } = router.query
  const isLoggedIn = auth?.isValid
  const isLiyFlow = flow === "liy"
  const formVariation = abTest === "true" ? 1 : 0

  const dispatch = useDispatch()
  const { isMasterclassAlias } = useDemoAlias()
  const source = mobileView ? "MWEB" : "WEB"

  const [isMenaUser, setIsMenaUser] = useState<boolean>(false)
  const [countryLoading, setCountryLoading] = useState<boolean>(false)

  useEffect(() => {
    setIsMenaUser(checkIfMENAUser(userCountry))
  }, [userCountry])

  const handleYtEvents = async () => {
    const { whenIelts, whatCareerStage } = formDetailsObjectFromQuery
    if (whenIelts === "BOOKED_EXAM" && whatCareerStage === "WORKING") {
      trackEventAsync("IELTS_YT_Working_AlreadyBooked")
      await fireTagEvent("IELTS_YT_Working_AlreadyBooked", {
        name: formDetailsObjectFromQuery["name"],
        hashed_email: sha256(formDetailsObjectFromQuery["emailId"]).toString(),
        hashed_phone: sha256(formDetailsObjectFromQuery["phone"]).toString(),
      })
    }
    if (whenIelts === "BOOKED_EXAM") trackEventAsync("IELTS_YT_AlreadyBooked")
  }

  const fetchSlotsAndPostFormDataFromQuery = async () => {
    if (formDetailsObjectFromQuery) handleYtEvents()
    const marketingEventName = isMasterclassAlias
      ? "Ielts demoMC lead marketing"
      : "Ielts demo lead marketing"
    const isNewUser = (router.query["isNewUser"] as string) || "0"
    if (formVariation != DemoFormAbVariants.FORM_1_CALENDAR_FORM_2) {
      if (!isObjectEmpty(formDetailsObjectFromQuery)) {
        await fireTagEvent(marketingEventName, {
          ...formDetailsObjectFromQuery,
          hashed_email: sha256(
            formDetailsObjectFromQuery["emailId"],
          ).toString(),
          hashed_phone: sha256(formDetailsObjectFromQuery["phone"]).toString(),
          isNewUser: isNewUser,
        })
        if (checkIfMENAUser(country as string)) {
          dispatch(
            updatePostFillIeltsEliteNudgeForm(() => {
              ieltsEliteApis.menaEventApi()
            }),
          )
        }
        dispatch(
          fetchPostIeltsEliteNudgeForm({
            ...formDetailsObjectFromQuery,
            source,
            qeEngineCallBack: async (QeType: UserQeData) => {
              if (leadSource === "EXPERIMENT_SALES_LEAD") {
                await trackEventAsync(
                  "Ielts demo lead marketing",
                  formDetailsObjectFromQuery,
                )
              } else {
                if (QeType === UserQeData.TYPE2) {
                  window.open("ielts-elite-demo/masterclass-calendar", "_self")
                } else {
                }
              }
            },
          }),
        )
        trackEventAsync("Ielts demo lead marketing", formDetailsObjectFromQuery)
      } else {
        dispatch(runIeltsQualificationEngineAction(false))
      }
    } else {
      dispatch(runIeltsQualificationEngineAction(false))
      if (!isObjectEmpty(formDetailsObjectFromQuery) && formStage === "1") {
        dispatch(setFormData(formDetailsObjectFromQuery))
      } else if (
        !isObjectEmpty(formDetailsObjectFromQuery) &&
        formStage === "2"
      ) {
        trackEventAsync("Ielts demo lead marketing", formDetailsObjectFromQuery)
        const isNewUser = (router.query["isNewUser"] as string) || "0"
        await fireTagEvent(marketingEventName, {
          ...formDetailsObjectFromQuery,
          hashed_email: sha256(
            formDetailsObjectFromQuery["emailId"],
          ).toString(),
          hashed_phone: sha256(formDetailsObjectFromQuery["phone"]).toString(),
          isNewUser: isNewUser,
        })
      }
    }
  }

  const viewLogic = async () => {
    dispatch(
      updatePostGetStageAction(async (studentStage) => {
        if (studentStage === IeltsStageType.LS_USER_ACQUIRED) {
        } else {
          fetchSlotsAndPostFormDataFromQuery()
        }
      }),
    )
    dispatch(fetchGetIeltsStage())
  }

  useEffect(() => {
    dispatch(fetchGetIeltsStage())
    dispatch(referAndEarnActions.fetchUserInfo())
    dispatch(fetchInboundSalesNumberSlice())
  }, [])

  useEffect(() => {
    if (userInfo.phone)
      if (formVariation == 0 || formVariation == 1) {
        viewLogic()
      }
  }, [formVariation, userInfo.phone, ieltsStage])

  useEffect(() => {
    const countryLoadingTimeout = setTimeout(() => {
      setCountryLoading(true)
    }, 1000)

    return () => clearTimeout(countryLoadingTimeout)
  }, [])

  if (!countryLoading) return <PageLoadingView />
  else if (isLiyFlow) return <LiyFlowThankyouPage />
  else
    return (
      <LiyThankyouPage2
        variant={
          isMenaUser
            ? liyABVariant.menaUser
            : isMobile
            ? abVariant
            : liyABVariant.allCourse
        }
      />
    )
}

export default withAuth(Calender, true)
